const sampleQueries: Record<string, any> = {
    "count sentences per language" :
{
    "distinct": true,
    "variables": [
        {
          "expression": {
            "type": "aggregate",
            "aggregation": "count",
            "distinct": false,
            "expression": {
              "termType": "Variable",
              "value": "Sentence"
            }
          },
          "variable": {
            "termType": "Variable",
            "value": "Sentence_count"
          }
        },
        {
          "termType": "Variable",
          "value": "Language"
        }
    ],
    "order": null,
    "branches": [
        {
            "line": {
                "s": "Sentence",
                "p": "https://w3id.org/SpOTy/shapes-ldo/Sentence_language",
                "o": "Language",
                "sType": "https://w3id.org/SpOTy/shapes-ldo/Sentence",
                "oType": "https://w3id.org/SpOTy/shapes-ldo/Language",
                "values": []
            },
            "children": []
        }
    ]
}
,
    "all sentences with a token CC=P" :
{
    "distinct": true,
    "variables": [
        {
            "termType": "Variable",
            "value": "Sentence"
        },
        {
            "termType": "Variable",
            "value": "Token"
        },
        {
            "termType": "Variable",
            "value": "Code_CC"
        },
        {
            "termType": "Variable",
            "value": "Code_MS"
        }
    ],
    "order": null,
    "branches": [
        {
            "line": {
                "s": "Sentence",
                "p": "https://w3id.org/SpOTy/shapes-ldo/Sentence_sentenceToken",
                "o": "Token",
                "sType": "https://w3id.org/SpOTy/shapes-ldo/Sentence",
                "oType": "https://w3id.org/SpOTy/shapes-ldo/Token",
                "values": []
            },
            "children": [
                {
                    "line": {
                        "s": "Token",
                        "p": "https://w3id.org/SpOTy/shapes-ldo/Token_tokenSemantics",
                        "o": "Semantics_4",
                        "sType": "https://w3id.org/SpOTy/shapes-ldo/Token",
                        "oType": "https://w3id.org/SpOTy/shapes-ldo/Semantics",
                        "values": [
                            {
                                "label": "P path",
                                "rdfTerm": {
                                    "type": "uri",
                                    "value": "https://w3id.org/SpOTy/ontology#CC-P"
                                }
                            }
                        ]
                    },
                    "children": []
                },
                {
                    "line": {
                        "s": "Token",
                        "p": "https://w3id.org/SpOTy/shapes-ldo/Token_semantics",
                        "o": "Semantics_6",
                        "sType": "https://w3id.org/SpOTy/shapes-ldo/Token",
                        "oType": "https://w3id.org/SpOTy/shapes-ldo/Semantics",
                        "values": []
                    },
                    "children": [
                        {
                            "line": {
                                "s": "Semantics_6",
                                "p": "https://w3id.org/SpOTy/shapes-ldo/Semantics_codeCC",
                                "o": "Code_CC",
                                "sType": "https://w3id.org/SpOTy/shapes-ldo/Semantics",
                                "oType": "https://w3id.org/SpOTy/shapes-ldo/Code",
                                "values": []
                            },
                            "children": []
                        }
                    ]
                },
                {
                    "line": {
                        "s": "Token",
                        "p": "https://w3id.org/SpOTy/shapes-ldo/Token_tokenMorphoSyntax",
                        "o": "MorphoSyntax_10",
                        "sType": "https://w3id.org/SpOTy/shapes-ldo/Token",
                        "oType": "https://w3id.org/SpOTy/shapes-ldo/MorphoSyntax",
                        "values": []
                    },
                    "children": [
                        {
                            "line": {
                                "s": "MorphoSyntax_10",
                                "p": "https://w3id.org/SpOTy/shapes-ldo/MorphoSyntax_codeMS",
                                "o": "Code_MS",
                                "sType": "https://w3id.org/SpOTy/shapes-ldo/MorphoSyntax",
                                "oType": "https://w3id.org/SpOTy/shapes-ldo/Code",
                                "values": []
                            },
                            "children": []
                        }
                    ]
                }
            ]
        }
    ],
    "limit": 500
},
    "all sentences whose first token has type F (figure), with the type of the second token" :
{
    "distinct": true,
    "variables": [
        {
            "termType": "Variable",
            "value": "Language"
        },
        {
            "termType": "Variable",
            "value": "Sentence"
        },
        {
            "termType": "Variable",
            "value": "CC_1st_token"
        },
        {
            "termType": "Variable",
            "value": "CC_2nd_token"
        },
        {
            "termType": "Variable",
            "value": "Transcription"
        }
    ],
    "order": null,
    "branches": [
        {
            "line": {
                "s": "Sentence",
                "p": "https://w3id.org/SpOTy/shapes-ldo/Sentence_firstToken",
                "o": "Token_2",
                "sType": "https://w3id.org/SpOTy/shapes-ldo/Sentence",
                "oType": "https://w3id.org/SpOTy/shapes-ldo/Token",
                "values": []
            },
            "children": [
                {
                    "line": {
                        "s": "Token_2",
                        "p": "https://w3id.org/SpOTy/shapes-ldo/Token_tokenSemantics",
                        "o": "Semantics_4",
                        "sType": "https://w3id.org/SpOTy/shapes-ldo/Token",
                        "oType": "https://w3id.org/SpOTy/shapes-ldo/Semantics",
                        "values": [
                            {
                                "label": "F figure",
                                "rdfTerm": {
                                    "type": "uri",
                                    "value": "https://w3id.org/SpOTy/ontology#CC-F"
                                }
                            }
                        ]
                    },
                    "children": []
                },
                {
                    "line": {
                        "s": "Token_2",
                        "p": "https://w3id.org/SpOTy/shapes-ldo/Token_semantics",
                        "o": "CC_1st_token",
                        "sType": "https://w3id.org/SpOTy/shapes-ldo/Token",
                        "oType": "https://w3id.org/SpOTy/shapes-ldo/Semantics",
                        "values": []
                    },
                    "children": []
                },
                {
                    "line": {
                        "s": "Token_2",
                        "p": "https://w3id.org/SpOTy/shapes-ldo/Token_nextToken",
                        "o": "Token_8",
                        "sType": "https://w3id.org/SpOTy/shapes-ldo/Token",
                        "oType": "https://w3id.org/SpOTy/shapes-ldo/Token",
                        "values": []
                    },
                    "children": [
                        {
                            "line": {
                                "s": "Token_8",
                                "p": "https://w3id.org/SpOTy/shapes-ldo/Token_semantics",
                                "o": "CC_2nd_token",
                                "sType": "https://w3id.org/SpOTy/shapes-ldo/Token",
                                "oType": "https://w3id.org/SpOTy/shapes-ldo/Semantics",
                                "values": []
                            },
                            "children": []
                        }
                    ]
                }
            ]
        },
        {
            "line": {
                "s": "Sentence",
                "p": "https://w3id.org/SpOTy/shapes-ldo/Sentence_language",
                "o": "Language",
                "sType": "https://w3id.org/SpOTy/shapes-ldo/Sentence",
                "oType": "https://w3id.org/SpOTy/shapes-ldo/Language",
                "values": []
            },
            "children": []
        },
        {
            "line": {
                "s": "Sentence",
                "p": "https://w3id.org/SpOTy/shapes-ldo/Sentence_transcription",
                "o": "Transcription",
                "sType": "https://w3id.org/SpOTy/shapes-ldo/Sentence",
                "oType": "https://w3id.org/SpOTy/shapes-ldo/Transcription",
                "values": []
            },
            "children": []
        }
    ],
    "limit": 500
},
    "clause number for all MS-H Multi-Head and Multi-Clause" :
{
    "distinct": true,
    "variables": [
        {
            "termType": "Variable",
            "value": "Sentence"
        },
        {
            "termType": "Variable",
            "value": "Token"
        },
        {
            "termType": "Variable",
            "value": "ClauseNumber"
        }
    ],
    "order": null,
    "branches": [
        {
            "line": {
                "s": "Token",
                "p": "https://w3id.org/SpOTy/shapes-ldo/Token_tokenMorphoSyntax",
                "o": "MorphoSyntax_2",
                "sType": "https://w3id.org/SpOTy/shapes-ldo/Token",
                "oType": "https://w3id.org/SpOTy/shapes-ldo/MorphoSyntax",
                "values": [
                    {
                        "label": "H head",
                        "rdfTerm": {
                            "type": "uri",
                            "value": "https://w3id.org/SpOTy/ontology#MS-H"
                        }
                    }
                ]
            },
            "children": []
        },
        {
            "line": {
                "s": "Token",
                "p": "https://w3id.org/SpOTy/shapes-ldo/Token_clause",
                "o": "ClauseNumber",
                "sType": "https://w3id.org/SpOTy/shapes-ldo/Token",
                "oType": "https://w3id.org/SpOTy/shapes-ldo/ClauseNumber",
                "values": []
            },
            "children": []
        },
        {
            "line": {
                "s": "Token",
                "p": "https://w3id.org/SpOTy/shapes-ldo/Token_tokenSentence",
                "o": "Sentence",
                "sType": "https://w3id.org/SpOTy/shapes-ldo/Token",
                "oType": "https://w3id.org/SpOTy/shapes-ldo/Sentence",
                "values": []
            },
            "children": []
        }
    ],
    "limit": 500
},
    "all languages with their geolocations" :
{
    "distinct": true,
    "variables": [
        {
            "termType": "Variable",
            "value": "Language"
        },
        {
            "termType": "Variable",
            "value": "Latitude"
        },
        {
            "termType": "Variable",
            "value": "Longitude"
        }
    ],
    "order": null,
    "branches": [
        {
            "line": {
                "s": "Language",
                "p": "https://w3id.org/SpOTy/shapes-ldo/Language_center",
                "o": "Center_2",
                "sType": "https://w3id.org/SpOTy/shapes-ldo/Language",
                "oType": "https://w3id.org/SpOTy/shapes-ldo/Center",
                "values": []
            },
            "children": [
                {
                    "line": {
                        "s": "Center_2",
                        "p": "https://w3id.org/SpOTy/shapes-ldo/Center_latitude",
                        "o": "Latitude",
                        "sType": "https://w3id.org/SpOTy/shapes-ldo/Center",
                        "oType": "https://w3id.org/SpOTy/shapes-ldo/Latitude",
                        "values": []
                    },
                    "children": []
                },
                {
                    "line": {
                        "s": "Center_2",
                        "p": "https://w3id.org/SpOTy/shapes-ldo/Center_longitude",
                        "o": "Longitude",
                        "sType": "https://w3id.org/SpOTy/shapes-ldo/Center",
                        "oType": "https://w3id.org/SpOTy/shapes-ldo/Longitude",
                        "values": []
                    },
                    "children": []
                }
            ]
        }
    ]
}
};
export default sampleQueries;
